import { render, staticRenderFns } from "./SimilarList.vue?vue&type=template&id=1480a49e&scoped=true&"
import script from "./SimilarList.vue?vue&type=script&lang=js&"
export * from "./SimilarList.vue?vue&type=script&lang=js&"
import style0 from "./SimilarList.vue?vue&type=style&index=0&id=1480a49e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1480a49e",
  null
  
)

export default component.exports